var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lamp-module"},[_c('div',{staticClass:"lamp-module-tree"},[_c('GroupTree')],1),_c('div',{staticClass:"lamp-module-box"},[(_vm.selectedNode.isChanghe)?_c('boxPage',{staticClass:"station-content"}):_vm._e(),_c('groupPage',{staticClass:"station-content"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }